export enum actionTypes {
    SET_ERROR = 'SET_ERROR',
    CLEAR_ERROR = 'CLEAR_ERROR'
}

export interface SetErrorAction {
    type: actionTypes.SET_ERROR;
    payload: String | null;
}

export interface ClearErrorAction {
    type: actionTypes.CLEAR_ERROR;
}

export type ErrorActions = SetErrorAction | ClearErrorAction;
